<template>
  <section class="custom-header">
    <div class="row">
      <!-- Week Selector -->
      <div class="col-md-2">
        <week-selector
          :weeks="weeks"
          :week="week"
          :isCoach="true"
          @change="weekChanged"
        />
      </div>
      <!-- Search -->
      <div class="col-md-3">
        <z-search
          class="mt-2"
          name="search"
          label=""
          placeholder="Search"
          v-model="searchTerm"
          @search="onSearch"
        />
      </div>
      <!-- Pagination -->
      <div class="col-md-7">
        <div class="row mt-2">
          <div class="col-md-1">
            <z-select
              v-model="pageSize"
              :options="pageSizes"
              @change="changePageSize"
            />
          </div>
          <div class="col-md-4">
            <nav>
              <z-paginate
                v-model="page"
                :page-count="pages"
                @change="changePage"
              />
            </nav>
          </div>
          <!-- Custom Views -->
          <div class="col-md-6">
            <div class="input-group">
              <span class="input-group-text">view</span>
              <select class="form-select" v-model="view" @change="clearRange">
                <option v-for="(view, idx) of customViews" :key="idx">
                  {{ view.name }}
                </option>
              </select>
              <button
                class="btn btn-primary btn-sm custom-action-button"
                @click="customizeView"
              >
                Customize
              </button>
            </div>
          </div>
          <!-- # Items -->
          <div class="col-md-1 custom-items">
            <h5 class="mr-2" title="# items">{{ numItems }}</h5>
            <span class="custom-items-label">items</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row custom-bottom-row">
      <!-- Filter As -->
      <div class="col-md-3 align-self-center">
        <filter-as
          :challenges="challenges"
          :lists="lists"
          @change="filterChanged"
        />
      </div>
      <!-- Limit By (range) -->
      <div class="col-md-4">
        <div v-if="isRange" class="input-group">
          <span class="input-group-text">limit by</span>
          <select class="form-select custom-limitby" v-model="rangeLimit">
            <option
              v-for="(column, idx) of columns"
              :key="idx"
              :value="column.name"
            >
              {{ column.label }}
            </option>
          </select>
          <input
            v-model="rangeMin"
            type="number"
            min="0"
            class="form-control custom-range"
            placeholder="min"
          />
          <span class="input-group-text">-</span>
          <input
            v-model="rangeMax"
            type="number"
            min="0"
            class="form-control custom-range"
            placeholder="max"
          />
          <span
            class="input-group-text custom-clear-range"
            title="clear limit"
            @click="clearRange"
          >
            <i class="fas fa-times"></i>
          </span>
          <button
            class="btn btn-link custom-action-button"
            title="refresh listing"
            @click="reload"
          >
            <i class="fas fa-sync-alt custom-reload"></i>
          </button>
        </div>
      </div>
      <!-- Action Buttons (Client Lists, User Cardio, Email) -->
      <div class="col-md-2">
        <button
          class="btn btn-link custom-action-button"
          title="manage your client lists"
          @click="showLists"
        >
          <i class="fas fa-list custom-actions"></i>
        </button>
        <button
          class="btn btn-link custom-action-button"
          title="set cardio goals"
          @click="setCardioGoals()"
        >
          <i class="fas fa-heartbeat custom-actions"></i>
        </button>
        <button
          class="btn btn-link custom-action-button"
          title="send messages"
          @click="sendMessage()"
        >
          <i class="fas fa-envelope custom-actions"></i>
        </button>
        <button
          v-if="isShowBI"
          class="btn btn-link custom-action-button custom-bi"
          title="send batch messages"
          @click="sendBiMessage()"
        >
          <span class="">B<span class="custom-italic">i</span></span>
          <i class="far fa-envelope custom-envelope"></i>
          <!-- <img
            src="/media/batch_intel.png"
            class="custom-actions"
            height="32"
            width="32"
          /> -->
        </button>
      </div>
      <div class="col-md-3"></div>
    </div>
    <!-- Dialogs (Client Lists, Custom Lists, User Cardio, Email) -->
    <custom-view-dialog
      :show="actionCustomView"
      @close="closeDialogs"
      @saved="savedCustomView"
      @cancel="cancelCustomView"
    />
    <list-dialog
      :show="actionLists"
      @close="closeDialogs"
      @saved="savedLists"
      @setCardioGoals="setCardioGoals"
      @sendMessage="sendMessage"
    />
    <set-cardio-goals :show="actionCardio" @close="closeDialogs" />
    <send-message :show="actionMessage" @close="closeDialogs" />
    <send-batch-message :show="actionBatchMessage" @close="closeDialogs" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import WeekSelector from '../elements/week-selector'
import CustomViewDialog from './custom-view-dialog'
import ListDialog from '../lists/list-dialog'
import CoachingDialog from '@/Components/Coaching/coaching-dialog'
import ChallengeDialog from '../challenges/challenge-dialog'
import SetCardioGoals from '../actions/set-cardio-goals'
import ZSearch from '@/Components/ZElements/Search'
import ZSelect from '@/Components/ZElements/Select'
import ZPaginate from '@/Components/ZElements/Paginate'
import SendMessage from '../actions/send-message.vue'
import SendBatchMessage from '../actions/batch-message.vue'
import FilterAs from '../elements/filter-as'
export default {
  name: 'manage-clients-header',
  components: {
    WeekSelector,
    CustomViewDialog,
    CoachingDialog,
    ZSearch,
    ZSelect,
    ZPaginate,
    ListDialog,
    SetCardioGoals,
    SendMessage,
    SendBatchMessage,
    FilterAs,
    ChallengeDialog,
  },
  props: {
    weeks: {
      type: Array,
      default: [],
    },
    pageSizes: {
      type: Array,
      default: [
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 },
        { name: '200', value: 200 },
        { name: '500', value: 500 },
      ],
    },
    columnFilter: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      actionCustomView: null,
      actionLists: null,
      actionCardio: null,
      actionMessage: null,
      actionBatchMessage: null,
    }
  },
  async mounted() {
    if (this.lists.length === 0) {
      await this.getLists(this.examineOrganization.id)
    }
    console.log('Your Lists', this.lists)
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('usercardio', [
      'pager',
      'summary',
      'filter',
      'lists',
      'customViews',
      'selectedView',
      'memberids',
    ]),
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.weekCoach.name
      }
      return _data
    },
    numItems() {
      let _items = 0
      if (this.pager) {
        _items = this.pager.total
      }
      return _items
    },
    pages() {
      let _pages = 1
      if (this.pager) {
        _pages = this.pager.pages ? this.pager.pages : 1
      }
      return _pages
    },
    pageSize: {
      get() {
        let _pageSize = 25
        if (this.pager) {
          _pageSize = this.pager.pageSize ? this.pager.pageSize : 25
        }
        return _pageSize
      },
      set(value) {
        this.page = 1
        this.setPager({
          name: 'pageSize',
          value: value,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
        this.setPager({
          name: 'search',
          value: '',
        })
      },
    },
    page: {
      get() {
        let _page = 1
        if (this.pager) {
          _page = this.pager.page ? this.pager.page : 1
        }
        return _page
      },
      set(value) {
        this.setPager({
          name: 'page',
          value: value,
        })
      },
    },
    searchTerm: {
      get() {
        let _search = null
        if (this.pager) {
          _search = this.pager.search
        }
        return _search
      },
      set(value) {
        this.setPager({
          name: 'search',
          value: value,
        })
      },
    },
    columns() {
      let _data = []
      this.columnFilter.forEach((element) => {
        if (element.isFilter) {
          _data.push({
            name: element.field,
            label: element.label,
            type: element.type,
          })
        }
      })
      console.log('Filter Columns', {
        source: this.columnFilter,
        columns: _data,
      })
      return _data
    },
    isRange() {
      let _data = false
      this.columnFilter.forEach((element) => {
        if (element.isFilter) {
          _data = true
        }
      })
      return _data
    },
    challenges() {
      let _data = []
      if (this.summary) {
        _data = this.summary.challenges
      }
      return _data
    },
    rangeLimit: {
      get() {
        let _data = null
        if (this.filter) {
          _data = this.filter.range.limit
        }
        return _data
      },
      set(value) {
        this.setFilter({
          name: 'range-limit',
          value: value,
        })
        this.setFilter({
          name: 'range-min',
          value: null,
        })
        this.setFilter({
          name: 'range-max',
          value: null,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
      },
    },
    rangeMin: {
      get() {
        let _data = 0
        if (this.filter) {
          _data = this.filter.range.min
        }
        return _data
      },
      set(value) {
        this.setFilter({
          name: 'range-min',
          value: value,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
      },
    },
    rangeMax: {
      get() {
        let _data = 0
        if (this.filter) {
          _data = this.filter.range.max
        }
        return _data
      },
      set(value) {
        this.setFilter({
          name: 'range-max',
          value: value,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
      },
    },
    view: {
      get() {
        let _data = null
        if (this.selectedView) {
          _data = this.selectedView.name
        }
        return _data
      },
      set(value) {
        console.log('Set Selected View', value)
        this.setSelectedView({ name: value })
      },
    },
    isShowBI() {
      let _is = false
      if (this.examineOrganization) {
        if (this.examineOrganization.isBatchIntel) {
          _is =
            parseInt(this.examineOrganization.isBatchIntel) === 1 ? true : false
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('coaching', ['getWallMessages', 'getMergeTags']),
    ...mapActions('usercardio', [
      'getMembers',
      'setPager',
      'setFilter',
      'getLists',
      'setSelectedView',
      'setChecked',
      'setCheckedInList',
    ]),
    ...mapActions('global', ['setLoading']),
    ...mapActions('coaching', ['setWorkingText']),
    ...mapActions('configuration', ['getBiTemplates']),
    closeDialogs() {
      this.actionCustomView = null
      this.actionLists = null
      this.actionCardio = null
      this.actionMessage = null
      this.actionBatchMessage = null
    },
    cancelCustomView() {
      this.actionCustomView = null
      this.$emit('search')
    },
    savedCustomView() {
      this.$emit('search')
      // this.actionCustomView = null
      // refresh
    },
    async savedLists() {
      this.actionLists = null
      // refresh
      await this.getLists(this.examineOrganization.id)
    },
    filterChanged() {
      this.$emit('search')
    },
    changePage() {
      this.$emit('search')
    },
    changePageSize() {
      this.$emit('search')
    },
    onSearch() {
      if (this.page > 1) {
        this.page = 1
      }
      this.setChecked({
        action: 'reset',
        checked: false,
      })
      this.$emit('search')
    },
    weekChanged() {
      this.$emit('search')
    },
    clearRange() {
      this.setFilter({
        name: 'range-limit',
        value: null,
      })
      this.setFilter({
        name: 'range-min',
        value: null,
      })
      this.setFilter({
        name: 'range-max',
        value: null,
      })
      this.setPager({
        name: 'page',
        value: 1,
      })
      this.$emit('search')
    },
    reload() {
      this.$emit('search')
    },
    async showLists() {
      this.closeDialogs()
      this.setCheckedInList()
      this.actionLists = {
        title: 'Manage Client Lists',
        orgid: this.examineOrganization.id,
      }
    },
    customizeView() {
      this.closeDialogs()
      this.actionCustomView = {
        title: 'Manage Custom Views',
      }
    },
    async setCardioGoals() {
      this.setLoading(true)
      this.closeDialogs()
      await this.getUserIds()
      let date = moment().format('YYYY-MM-DD')
      let data = {
        orgid: this.examineOrganization.id,
        date: date,
        isMultiple: true,
      }
      console.log('Showing Set Cardio Goals', data)
      this.actionCardio = data
      this.setLoading(false)
    },
    async getUserIds() {
      if (this.summary) {
        let date = moment(this.summary.weekCoach.value).format('YYYY-MM-DD')
        let columns = []
        this.selectedView.columns.forEach((column) => {
          columns.push(column.code)
        })
        let filter = null
        let range = {
          min: null,
          max: null,
        }
        if (this.filter) {
          if (this.filter.filterAs) {
            console.log('Get User Ids - Filter As', this.filter)
            if (this.filter.filterAs === -1) {
              filter = 'star'
            } else if (this.filter.filterAs === -2) {
              filter = 'nonstar'
            } else if (this.filter.filterAs === -3) {
              filter = null
            } else if (this.filter.filterAs === -4) {
              filter = 'new'
            } else if (this.filter.filterAs !== '') {
              filter = this.filter.filterAs
            }
          }
          if (this.filter.range) {
            range.limit = this.filter.range.limit
            if (parseInt(this.filter.range.min) >= 0) {
              range.min = parseInt(this.filter.range.min)
            }
            if (parseInt(this.filter.range.max) >= 0) {
              range.max = parseInt(this.filter.range.max)
            }
          }
        }
        console.log('GetUserIds: Calling getMembers')
        await this.getMembers({
          orgid: this.examineOrganization.id,
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: 'LastName',
          orderBy: 'asc',
          search: this.pager.search,
          dateStart: date,
          filter: filter,
          rangelimit: range.limit,
          rangemin: range.min,
          rangemax: range.max,
          columns: columns,
          forEmail: 1,
        })
      }
    },
    async sendMessage() {
      this.setLoading(true)
      this.closeDialogs()
      await this.getMergeTags()
      await this.getUserIds()
      this.setWorkingText(null)
      let data = {
        orgid: this.examineOrganization.id,
        id: null,
        type: 'notification',
      }
      console.log('Send Message', this.memberids)
      this.actionMessage = data
      this.setLoading(false)
    },
    async sendBiMessage() {
      this.setLoading(true)
      this.closeDialogs()
      await this.getMergeTags()
      await this.getUserIds()
      await this.getBiTemplates({
        name: 'BatchIntel',
        classification: 'Templates',
      })
      let data = {
        orgid: this.examineOrganization.id,
        id: null,
        type: 'notification',
      }
      this.actionBatchMessage = data
      this.setLoading(false)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  margin-bottom: 5px;
}
.custom-items-label {
  position: relative;
  top: -10px;
}
.custom-actions {
  font-size: 1.5em;
}
.custom-range {
  text-align: right;
  max-width: 80px;
}
.custom-action-button:focus {
  box-shadow: none !important;
}
.custom-reload {
  font-size: 1.2em;
  top: 1px;
  position: relative;
}
.custom-bottom-row {
  padding-bottom: 5px;
}
.custom-clear-range {
  cursor: pointer;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.custom-limitby {
  max-width: 400px;
}
.custom-bi {
  font-size: 1.5em;
  line-height: normal;
  text-decoration: none;
  font-family: none;
  font-weight: 600;
  z-index: 5;
  position: relative;
}
.custom-italic {
  font-style: italic;
}
.custom-envelope {
  z-index: 0;
  position: absolute;
  top: 2px;
  right: 1px;
  color: rgb(163, 163, 163);
  font-size: 0.7em;
}
</style>
